import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    const s = localStorage.getItem('bd_cart');
    return s ? JSON.parse(s) : [];
  });

  useEffect(() => {
    localStorage.setItem('bd_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, variant = '') => {
    setItems(prev => {
      const key = `${product._id}-${variant}`;
      const exists = prev.find(i => `${i._id}-${i.variant}` === key);
      if (exists) {
        return prev.map(i =>
          `${i._id}-${i.variant}` === key
            ? { ...i, quantity: Math.min(i.quantity + quantity, product.stock) }
            : i
        );
      }
      return [...prev, { ...product, quantity, variant }];
    });
  };

  const removeItem = (id, variant = '') => {
    setItems(prev => prev.filter(i => !(i._id === id && i.variant === variant)));
  };

  const updateQty = (id, variant = '', quantity) => {
    if (quantity < 1) return removeItem(id, variant);
    setItems(prev =>
      prev.map(i => (i._id === id && i.variant === variant) ? { ...i, quantity } : i)
    );
  };

  const clearCart = () => setItems([]);

  const itemCount = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal  = items.reduce((s, i) => s + (i.discountPrice || i.price) * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, itemCount, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
